<div class="container-fluid mc-flex-container">
  <div class="mc-value mc-value-actions">
    @if (canRead) {
      @if (isTextual) {
        <div class="mc-row-icon mc-text" (click)="read()" data-testid="link-read">Read</div>
      }
      @if (!isTextual) {
        <span class="mc-row-icon mc-read-icon" (click)="read()" placement="top" ngbTooltip="Read Content" data-testid="icon-read-content">
          <svg class="icon small info-grey">
            <use xlink:href="#shape-folder-open" />
          </svg>
        </span>
      }
    }
    @if (canAnalyse) {
      @if (isTextual) {
        <div class="mc-row-icon mc-text" (click)="analyse()" data-testid="link-analyse">Analyse</div>
      }
      @if (!isTextual) {
        <span
          class="mc-row-icon mc-analyse-icon"
          (click)="analyse()"
          placement="top"
          ngbTooltip="Open in Analyse"
          data-testid="link-analyse"
        >
          <a>Analyse</a>
        </span>
      }
    }

    @if (canEdit) {
      <span class="mc-row-icon mc-edit-icon" (click)="edit()" placement="top" ngbTooltip="Edit" data-testid="icon-edit">
        <grid-ui-icon class="icon" name="edit"></grid-ui-icon>
      </span>
    }

    @if (canDownload) {
      <a [href]="downloadUrl" target="_blank">
        <span class="mc-row-icon mc-download-icon" placement="top" ngbTooltip="Download" data-testid="icon-download">
          <grid-ui-icon class="icon" name="download"></grid-ui-icon>
        </span>
      </a>
    }

    @if (canExtract) {
      <span class="mc-row-icon mc-download-icon" (click)="extract()" placement="top" ngbTooltip="Extract data" data-testid="icon-extract">
        <grid-ui-icon class="icon" name="download"></grid-ui-icon>
      </span>
    }

    @if (canShareOrDeleteAsCreator || canDelete) {
      <span class="mc-row-icon mc-delete-icon" (click)="delete()" placement="top" ngbTooltip="Delete" data-testid="icon-delete">
        <grid-ui-icon class="icon" name="bin"></grid-ui-icon>
      </span>
      @if (canShareOrDeleteAsCreator) {
        <span
          class="mc-row-icon mc-share-icon"
          (click)="share()"
          [class.mc-shared]="isShared"
          placement="top"
          [ngbTooltip]="isShared ? 'Sharing options' : 'Bookmark or Share'"
          [attr.data-testid]="isShared ? 'icon-sharing-options' : 'icon-bookmark-or-share'"
        >
          <grid-ui-icon class="icon" [name]="isShared ? 'people-plus' : 'people'"></grid-ui-icon>
        </span>
      }
    }

    @if (canRemove) {
      <div class="mc-row-icon mc-text mc-unshare" (click)="delete()" data-testid="icon-remove">Remove</div>
    }

    @if (canUnshare) {
      <div class="mc-row-icon mc-text mc-unshare mc-unshare--underline" (click)="unshare()" data-testid="icon-unshare">Unshare</div>
    }

    @if (canSubscribe) {
      @if (isTextual) {
        <div class="mc-row-icon mc-text" (click)="subscribe()" data-testid="link-subscribe">Subscribe</div>
      }
      @if (!isTextual) {
        <span
          class="mc-row-icon mc-subscribe-icon"
          (click)="subscribe()"
          placement="top"
          ngbTooltip="Subscribe"
          data-testid="icon-subscribe"
        >
          <svg class="icon small info-grey">
            <use xlink:href="#shape-plus" />
          </svg>
        </span>
      }
    }

    @if (canCopy) {
      <span class="mc-row-icon mc-copy-icon" (click)="copy()" placement="top" ngbTooltip="Copy" data-testid="icon-copy">
        <grid-ui-icon class="icon" name="copy"></grid-ui-icon>
      </span>
    }
  </div>
</div>
